import { unlessCommonError } from "source/CommonErrorBoundary"
import { createApi } from "source/registrations/api/client"
import {
  useSuspenseQuery,
  splitQueryParams,
  queryFn,
} from "source/registrations/utils/queryCache"

const FIELDS = {
  Event: [
    "allow_credit_card_payments",
    "allow_ach_payments",
    "allow_minimum_deposits",
    "allow_offline_payments",
    "allowed_registrations",
    "can_register_household_members",
    "can_register_outside_members",
    "contact",
    "currency",
    "discounts",
    "event_times",
    "free",
    "guest_mode",
    "has_addons_module",
    "has_attendee_questions_module",
    "has_attendees_module",
    "has_payments_module",
    "has_registrant_questions_module",
    "maximum_registration_attendees",
    "name",
    "online_payment_methods",
    "recent_registration_details",
    "recent_registration_urls",
    "register_for_separate_times",
    "registrant_collection_options",
    "registration_type",
  ],
  EventTime: [
    "at_maximum_capacity",
    "available_for_registrations",
    "date",
    "time",
    "all_day",
    "starts_at",
    "available_capacity",
  ],
  Discount: ["kind", "is_expired", "restricted_to"],
}

export const eventQuery = (id, options = {}, { apiClient } = {}) => {
  const path = `/registrations/v2/events/${id}`
  const { params, queryOptions } = splitQueryParams(options)
  const registrationsApi = apiClient && createApi(apiClient)

  return {
    queryFn: registrationsApi
      ? (context) => queryFn({ ...context, registrationsApi })
      : queryFn,
    queryKey: [
      path,
      {
        include: ["event_times", "discounts", "contact"],
        fields: FIELDS,
        ...params,
      },
    ],
    retry: unlessCommonError,
    ...queryOptions,
  }
}

export const useEvent = (id, options = {}) =>
  useSuspenseQuery(eventQuery(id, options))
